export function getRandomBetweenNegativeAndPositive(x: number) {
    const randomNumber = Math.random();
    const randomBetweenNegativeXAndX = randomNumber * (2 * x) - x;
    return randomBetweenNegativeXAndX;
}
